import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {SubscribedUser} from '@paperlessio/sdk/api/models';
import {UserAvatarMode} from '@shared/user-avatar/user-avatar.type';

@Component({
  selector: 'app-user-avatar-list-item',
  templateUrl: './user-avatar-list-item.component.html',
  styleUrls: ['./user-avatar-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarListItemComponent {
  @Input() user: SubscribedUser;
  @Input() mode: UserAvatarMode = UserAvatarMode.default;
  @Input() isOverflowButton = false;
  @Input() text: string;
  @Input() index = 0;
  @Input() dropdownIsOpen = false;

  // tslint:disable-next-line:variable-name
  _isVisible = true;

  @Input('isVisible') set isVisible(value: boolean) {
    this._isVisible = value;
    this.changeDetectorRef.markForCheck();
  }

  get isVisible() {
    return this._isVisible;
  }

  UserAvatarMode = UserAvatarMode;

  get translateX() {
    return this.index * (this.mode === UserAvatarMode.default ? 8 : 6);
  }

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }
}
